var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full"},[_c(_vm.activeNumberMod,{tag:"component",attrs:{"editObj":_vm.editObj,"numberKeys":_vm.numberKeys,"numbers":_vm.numbers}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }